module.exports = __webpack_public_path__ + "img/GR081.be4c740d.svg";